// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeComponent_darkTheme__BF7cf {
  font-family: "Courier New", monospace;
  font-size: 1.2rem;
  background-color: #212121;
  color: #fafafa;
}
.ThemeComponent_darkTheme__BF7cf a {
  color: white;
}

.ThemeComponent_lightTheme__tUwDf {
  font-family: "Courier New", monospace;
  font-size: 1.2rem;
  background-color: #fafafa;
  color: #212121;
}
.ThemeComponent_lightTheme__tUwDf a {
  color: #212121;
}

.ThemeComponent_colorfulTheme__oD2OF {
  font-family: "Courier New", monospace;
  font-size: 1.2rem;
  background-color: #91f88b;
  color: #212121;
}
.ThemeComponent_colorfulTheme__oD2OF a {
  color: #212121;
}

.ThemeComponent_darkThemeContent__PuKdv {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, 0.05);
}

.ThemeComponent_lightThemeContent__xi3EY {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
}

.ThemeComponent_colorfulThemeContent__B4XqA {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/components/ThemeComponent/ThemeComponent.module.scss","webpack://./src/assets/_globalStyleElements.module.scss"],"names":[],"mappings":"AAEA;ECyBE,qCA3BiB;EA4BjB,iBA3Be;EA4Bf,yBAvBgB;EAwBhB,cAvBiB;ADFnB;AC0BE;EACE,YAAA;ADxBJ;;AAFA;EC+BE,qCArCiB;EAsCjB,iBArCe;EAsCf,yBAhCiB;EAiCjB,cAlCgB;ADSlB;AC0BE;EACE,cApCc;ADYlB;;AARA;ECqCE,qCA/CiB;EAgDjB,iBA/Ce;EAgDf,yBAAA;EACA,cA5CgB;ADmBlB;AC0BE;EACE,cA9Cc;ADsBlB;;AAdA;EC2CE,gBAAA;EACA,sBAAA;EACA,2CAnD4B;AD0B9B;;AAhBA;EC6CE,gBAAA;EACA,sBAAA;EACA,0CAxD6B;AD+B/B;;AAlBA;EC+CE,gBAAA;EACA,sBAAA;EACA,0CA9D6B;ADqC/B","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.darkTheme {\n  @include darkTheme;\n}\n\n.lightTheme {\n  @include lightTheme;\n}\n\n.colorfulTheme {\n  @include colorfulTheme;\n}\n\n.darkThemeContent {\n  @include darkThemeContent;\n}\n\n.lightThemeContent {\n  @include lightThemeContent;\n}\n\n.colorfulThemeContent {\n  @include colorfulThemeContent;\n}\n","$globalFontFamily: 'Courier New', monospace;\n$globalFontSize: 1.2rem;\n\n$globalBorderRadius: 1rem;\n$globalHomeContentContainerPadding: 2.5rem;\n\n$globalDarkColor: #212121;\n$globalLightColor: #fafafa;\n$globalUnderlayRGBAColorDark: rgba(255, 255, 255, 0.05);\n$globalUnderlayRGBAColorLight: rgba(208, 209, 255, 0.5);\n\n$globalHighlightColor: #f6a3a0;\n$globalHighlightColorDark: #fafafa;\n$globalHighlightColorLight: #454555;\n\n\n$colorsReact: #61dafb;\n$colorsKotlin: #7f52ff;\n$colorsReactRgba: rgba(97, 218, 251, 0.2);\n\n$gradientColor1: #845ec2;\n$gradientColor1: #d65db1;\n$gradientColor1: #ff9671;\n$gradientColor1: #ffc75f;\n$gradientColor1: #f9f871;\n\n@mixin darkTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalDarkColor;\n  color: $globalLightColor;\n  a {\n    color: white;\n  }\n}\n\n@mixin lightTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalLightColor;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin colorfulTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: #91f88b;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin darkThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorDark;\n}\n\n@mixin lightThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n\n@mixin colorfulThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"darkTheme": `ThemeComponent_darkTheme__BF7cf`,
	"lightTheme": `ThemeComponent_lightTheme__tUwDf`,
	"colorfulTheme": `ThemeComponent_colorfulTheme__oD2OF`,
	"darkThemeContent": `ThemeComponent_darkThemeContent__PuKdv`,
	"lightThemeContent": `ThemeComponent_lightThemeContent__xi3EY`,
	"colorfulThemeContent": `ThemeComponent_colorfulThemeContent__B4XqA`
};
export default ___CSS_LOADER_EXPORT___;
